<template>
  <Container type="card-full">
    <div slot="header">
      <el-button  @click="saveBrowscol">保存</el-button>
      <el-button  @click="sortBrowscol">重新排序</el-button>
      <el-button  @click="showsql">显示sql</el-button>
      <!-- <el-button  @click="close">关闭</el-button> -->
    </div>
    <el-form :model="brows" ref="form" label-position="left" label-width="100px">
      <el-form-item label="完整sql" v-if="browssql">
        <el-input v-model="browssql" :maxlength="1024" type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="过滤条件">
        <el-input v-model="brows.browswhere" :maxlength="1024" type="textarea"></el-input>
      </el-form-item>
    </el-form>
    <vggrid ref="xGrid" :list="list" tableheight="500" flexname="browscolflex"
            :cols="cols" :showfooter="false" :showPage="false" :resizable="true"
            :needSelection="true"
            :needRowNum="false"
            :canbeEdit="true"
            @cellClick="cellClick">
    </vggrid>
  </Container>
</template>
<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import vggrid from '../common/vggrid'
  export default {
    name: 'browscolForm',
    data () {
      return {
        list: [],
        brows: this.$route.params.form,
        cols: [
          { type:  'selection',fieldtype: 'C', title: '选择', calculExpr:'',width: 80 },
          { field: 'seq', title: '序号',calculExpr:'', addNewRowFlg: false, editRender: { name: 'input'}},
          { field: 'dsfieldcode', title: '列名',calculExpr:'',addNewRowFlg: false},
          { field: 'dsfieldname', title: '列说明',calculExpr:'',addNewRowFlg: false},
          { field: 'dsfieldsortflg', title: '排序',calculExpr:'',addNewRowFlg: false,syscode: 'browscolsortflg',editRender: { name: 'select', options: []}}
        ],
        form: {},
        browssql: '',
        loading: true
      }
    },
    created () {
    },
    activated() {
      this.init()
      this.getBrowscolList()
    },
    mounted () {
    },
    components: {vggrid},
    methods: {
      async init() {
        this.list = []
        this.brows = this.$route.params.form
        this.form = {}
        this.browssql = ''
        this.loading = true
      },
      async showsql() {
        this.browssql = this.brows.browsselect + this.brows.browsfrom + ' ' + this.brows.browswhere + this.brows.browsorderby
      },
      async sortBrowscol () {
        let model = {
          browscols:this.list,
          browsid: this.brows.browsid,
          dsid: this.brows.browsdsid,
          browswhere: this.brows.browswhere
        }
        let data = await request({
          url: '/kfgl/brows/sortBrowscol',
          method: "post",
          data: model
        })
        if (data.issuccess === 1) {
          this.getBrowscolList()
          this.$message.success('排序成功！')
        } else {
          this.$message.error('排序失败！')
        }
      },
      async saveBrowscol () {
        let model = {
          browscols:this.$refs.xGrid.$refs.xGrid.getSelectRecords(),
          browsid: this.brows.browsid,
          dsid: this.brows.browsdsid,
          browswhere: this.brows.browswhere
        }

        await request({
          url: '/kfgl/brows/saveBrowscol',
          method: "post",
          data: model
        })
        this.$message.success('操作成功')
        await this.getBrowscolList()
      },
      async cellClick (row) {
        this.form = row.row
      },
      async pagechange (fcPage) {
        this.query.currPage = fcPage.currentPage
        this.query.pageSize = fcPage.pageSize
        this.getBrowscolList()
      },
      async getBrowscolList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/kfgl/brows/getBrowscolListByBrowsid',
          params: {browsid: this.brows.browsid,dsid: this.brows.browsdsid}
        })
        this.list = res
        this.loading = false
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'browsIndex'})

      }
    },
    filters: {
    }
  }
</script>

<style lang="scss" scoped>
</style>
